"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BentoReportingService = exports.bentoReportingService = void 0;
var analytics_service_1 = require("../analytics/analytics.service");
var global_bento_lib_1 = require("./global-bento-lib");
var sendAnalyticsIds = function (request) {
    return analytics_service_1.analyticsService.sendAnalyticsIds(request);
};
var triggerOnNewPage = function (reportEventConfig) {
    global_bento_lib_1.globalBentoLib.onNewPage(reportEventConfig);
};
exports.bentoReportingService = {
    sendAnalyticsIds: sendAnalyticsIds,
    triggerOnNewPage: triggerOnNewPage,
};
var BentoReportingService = /** @class */ (function () {
    function BentoReportingService() {
        return exports.bentoReportingService;
    }
    return BentoReportingService;
}());
exports.BentoReportingService = BentoReportingService;
